import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../contexts/AdminAuthContext';
import client from '../api/client';

export default function Voters() {
  const { admin } = useAdminAuth();
  const navigate = useNavigate();
  const [voters, setVoters] = useState([]);
  const [constituencies, setConstituencies] = useState([]);
  const [form, setForm] = useState({ name: '', national_id: '', password: '', constituency_id: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [selectedVoter, setSelectedVoter] = useState(null);

  useEffect(() => {
    if (!admin) { navigate('/admin/login'); return; }
    loadVoters();
    client.get('/admin/constituencies').then(res => setConstituencies(res.data)).catch(() => {});
  }, [admin, navigate]);

  const loadVoters = () => {
    client.get('/voter').then(res => setVoters(res.data)).catch(() => {});
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    setError(''); setSuccess('');
    try {
      await client.post('/voter', form);
      setSuccess('Voter registered successfully');
      setForm({ name: '', national_id: '', password: '', constituency_id: '' });
      loadVoters();
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to register voter');
    }
  };

  const viewVoter = async (id) => {
    try {
      const res = await client.get(`/voter/${id}`);
      setSelectedVoter(res.data);
    } catch (err) {}
  };

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1>Voters</h1>
        <Link to="/admin/dashboard" className="btn-secondary">Back</Link>
      </div>

      {selectedVoter && (
        <div className="modal-overlay" onClick={() => setSelectedVoter(null)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <h2>Voter Detail</h2>
            <p><strong>Name:</strong> {selectedVoter.name}</p>
            <p><strong>National ID:</strong> {selectedVoter.national_id}</p>
            <p><strong>Constituency:</strong> {selectedVoter.constituency_name}</p>
            <p><strong>Has Voted:</strong> {selectedVoter.has_voted ? 'Yes' : 'No'}</p>
            {selectedVoter.voted_at && <p><strong>Voted At:</strong> {new Date(selectedVoter.voted_at).toLocaleString()}</p>}
            <button onClick={() => setSelectedVoter(null)} className="btn-secondary">Close</button>
          </div>
        </div>
      )}

      <div className="card">
        <h2>Register New Voter</h2>
        {error && <div className="error-msg">{error}</div>}
        {success && <div className="success-msg">{success}</div>}
        <form onSubmit={handleAdd}>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="voter-name">Name</label>
              <input id="voter-name" name="name" type="text" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} required />
            </div>
            <div className="form-group">
              <label htmlFor="voter-national_id">National ID</label>
              <input id="voter-national_id" name="national_id" type="text" value={form.national_id} onChange={e => setForm({ ...form, national_id: e.target.value })} required />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="voter-password">Password</label>
              <input id="voter-password" name="password" type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} required />
            </div>
            <div className="form-group">
              <label htmlFor="voter-constituency_id">Constituency</label>
              <select id="voter-constituency_id" name="constituency_id" value={form.constituency_id} onChange={e => setForm({ ...form, constituency_id: e.target.value })} required>
                <option value="">Select Constituency</option>
                {constituencies.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
              </select>
            </div>
          </div>
          <button type="submit" className="btn-primary">Register Voter</button>
        </form>
      </div>

      <div className="table-container">
        <h2>All Voters ({voters.length})</h2>
        <table>
          <thead>
            <tr>
              <th>National ID</th>
              <th>Name</th>
              <th>Constituency</th>
              <th>Has Voted</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {voters.map(v => (
              <tr key={v.id}>
                <td>{v.national_id}</td>
                <td>{v.name}</td>
                <td>{v.constituency_name}</td>
                <td>{v.has_voted ? '✓' : '—'}</td>
                <td>
                  <button onClick={() => viewVoter(v.id)} className="btn-secondary">View</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
